<template>
  <div>
    <div
      v-if="hasImage"
      class="icon-image"
    >
      <AImage
        :img="getImage"
        :preset="getPreset"
        :ratio="getRatio"
        contain
      />
    </div>
    <div class="content">
      <div class="title">
        <h3>
          {{ getFeatureTitle }}
        </h3>
      </div>
      <div
        class="description"
        v-html="getFeatureDescription"
      />
      <div
        v-if="hasFeatureButton"
        class="action"
      >
        <component
          :is="linkComponent"
          :to="{ path: getFeatureButton.url }"
          :href="$options.filters.toUrl(getFeatureButton.url)"
        >
          {{ getFeatureButton.title }}
        </component>
      </div>
    </div>
  </div>
</template>

<script>

import layoutMixin from './layouts-mixin'

export default {
  name: 'sp-feature-image-title-description-button',
  mixins: [layoutMixin]
}
</script>

<style lang="scss" scoped>
  .icon-image {
    display: flex;
    align-items: initial;
    flex-direction: column;
    align-items: center;
  }

  .icon-image {
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .action {
    display: flex;
    align-items: flex-end;
    height: 100%;
    a {
      font-size: 1.1em;
      color: var(--main-highlight-color);
    }
  }
</style>
